import { IncidentAndDamage, Person } from './model';
import { CaseResponse } from '../../../store/case/model';

export interface DetailsCaseState {
  readonly caseCode: string;
  readonly incidentAndDamage: IncidentAndDamage;
  readonly policyHolderRepresentative: Person;
  readonly policyHolderCounterExpert: Person;
  readonly responsableParty: Person;
  readonly responsablePartyExpert: Person;
  readonly witnesses: Person[];
  readonly injuredPersons: Person[];
  readonly personsHadDamage: Person[];
  readonly case: CaseResponse;

  // MOVE EVERYTHING TO OVERVIEW
  // readonly communicationOverviewRimList: CommunicationOverviewRimItem[];
  // readonly communicationOverviewRimSelectedIds: string[];
}

export const enum DetailsCaseActionTypes {
  FETCH_CASE_VIEW = '@@detailsCase/FETCH_CASE_VIEW',
  FETCH_CASE_VIEW_FAIL = '@@detailsCase/FETCH_CASE_VIEW_FAIL',
  FETCH_CASE_VIEW_SUCCESS = '@@detailsCase/FETCH_CASE_VIEW_SUCCESS',
  RESET_STATE = '@@detailsCase/RESET_STATE'
}
